export default __webpack_public_path__ + "static/media/energie.227434a2.svg";